import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Link } from 'react-router-dom'
import { positionDropdown } from '../../../common/dropdown'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import { Tooltip } from '../../../common/tooltip'
import { formatVal } from '../../../helpers/value'
import { COMPONENTS } from '../../../routers/constants'
import { selectProfileById } from '../store/slice'

export const PortfolioCell = ({ rowId, data }) => {
  const locale = useSelector((state) => state.i18n.locale)

  const profileSetting = useSelector(selectProfileById(rowId))
  const isFollowingProfile = profileSetting.isFollowingList

  if (isFollowingProfile) {
    return (
      <Element style={{ color: '#2C73E8' }}>
        <Link
          to={COMPONENTS.library.components.followingList.route}
          target="_blank"
        >
          <Translate value="library.main.FOLLOWING_LIST" />
        </Link>
      </Element>
    )
  }

  if (!data) return null

  return (
    <Tooltip
      tooltipContent="alertSetting.PORTFOLIO_TOOLTIP"
      isI18n
      position={positionDropdown.TOP_CENTER}
      contentClass="wFitContent dFlex alignItemsEnd"
    >
      <Icon
        className="icon-folder"
        style={{
          fontSize: 13,
          color: '#FFCD60',
          marginRight: 3,
        }}
      />

      <span>{formatVal(data, locale, false, 0)}</span>
    </Tooltip>
  )
}
